<template>
  <v-container fluid>
    <main-header-plat-a />
    <main-header-plat-b :navBItems="schema.navBItems" />
    <v-overlay-loader />
    <v-row class="flex-nowrap">
      <div class="barLateral">
        <v-nav-draw-anam :anamIndex="anamIndex" :anamGroupShow="anamGroupShow" />
      </div>
      <div class="contentCentral">
        <v-card-form-anam :anamRoute="schema.anamRoute" :observerHCP="observerHCP" />
        <v-card class="contentCardCentral secundary5" flat>
          <v-row class="mx-auto contentRowCentral justify-center">
            <v-col cols="12">
              <v-card-subtitle> Pensamientos Relevantes </v-card-subtitle>
              <div style="position: relative">
                <v-items-add-remove :items.sync="modelListProxy1" @input="handleEvents" />
                <v-sheet
                  v-if="observerHCP === true"
                  color="transparent"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 93%; z-index: 10"
                  class="rounded-lg"
                  @mousedown.stop.prevent
                  @click.stop.prevent
                >
                </v-sheet>
              </div>
            </v-col>
            <v-col cols="12" class="mt-10">
              <v-card-subtitle> Representaciones Disruptivas </v-card-subtitle>
              <div style="position: relative">
                <v-items-add-remove :items.sync="modelListProxy2" @input="handleEvents" />
                <v-sheet
                  v-if="observerHCP === true"
                  color="transparent"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 93%; z-index: 10"
                  class="rounded-lg"
                  @mousedown.stop.prevent
                  @click.stop.prevent
                >
                </v-sheet>
              </div>
            </v-col>
          </v-row>
          <v-overlay
            :value="overlay"
            @update:value="overlay = $event"
            class="d-flex align-star justify-center"
            style="z-index: 1000; position: absolute"
          >
            <v-row class="d-flex justify-center my-5">
              <v-card min-height="200" width="70%" class="secundary6">
                <v-card-title class="text-body-1 font-weight-bold justify-center">
                  Aviso
                </v-card-title>
                <v-card-text class="text-body-2">
                  {{ overlayMessage }}
                </v-card-text>
                <v-card-actions class="mx-auto mb-5">
                  <v-btn
                    color="primary"
                    class="d-flex mx-auto justify-center"
                    @click="toggleOverlay()"
                  >
                    IR A INDEX
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-row>
          </v-overlay>
          <v-row class="mx-auto bannerAction ma-0 pa-0">
            <v-col class="ma-0 pa-0">
              <v-banner-action-form
                :bannerActionItems="schema.bannerActionItems"
                :save="save"
                :nextPage="schema.nextPage"
                v-if="observerHCP === false"
              />
            </v-col>
            <v-snack-bar :snackbar="snackbar" />
          </v-row>
        </v-card>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderPlatA from '@/components/includes/MainHeaderPlatA.vue';
import MainHeaderPlatB from '@/components/includes/MainHeaderPlatB.vue';
import VOverlayLoader from '@/components/base/VOverlayLoader.vue';
import VNavDrawAnam from '@/components/base/VNavDrawAnam.vue';
import VCardFormAnam from '@/components/base/VCardFormAnam.vue';
import VItemsAddRemove from '@/components/base/VItemsAddRemove.vue';
import VBannerActionForm from '@/components/base/VBannerActionForm.vue';
import VSnackBar from '@/components/base/VSnackBar.vue';

export default {
  name: 'CAxACGxThoughtPt2Page',
  components: {
    MainHeaderPlatA,
    MainHeaderPlatB,
    VOverlayLoader,
    VNavDrawAnam,
    VCardFormAnam,
    VItemsAddRemove,
    VBannerActionForm,
    VSnackBar,
  },

  data: () => ({
    overlay: false,
    overlayMessage: '',
  }),

  computed: {
    ...mapGetters('anamCAxACGxThoughtPt2', [
      'schema',
      'modelList1',
      'modelList2',
      'numCog',
      'status',
    ]),
    ...mapGetters('anamPermissions', ['anamIndex', 'anamGroupShow','hasPermission', 'observerHCP']),
    ...mapGetters('notifications', ['snackbar']),

    modelListProxy1: {
      get() {
        return Array.isArray(this.modelList1) ? this.modelList1 : [];
      },
      set(value) {
        this.updateModelList1(value);
      }
    },

    modelListProxy2: {
      get() {
        return Array.isArray(this.modelList2) ? this.modelList2 : [];
      },
      set(value) {
        this.updateModelList2(value);
      }
    }
  },

  mounted() {
    this.loadData();
    this.loadPermissionsHCP();
    this.loadObserverHCP();
  },

  methods: {
    ...mapActions('anamCAxACGxThoughtPt2', [
      'fetchSchema',
      'fetchRecords',
      'createRecord',
      'updateRecord',
      'updateModelList1',
      'updateModelList2'
    ]),
    ...mapActions('anamPermissions', ['loadPermissionsHCP', 'loadObserverHCP']),
    ...mapActions('anamPermissions', ['sectionsHCPandRoute', 'checkPermission', 'loadObserverHCP']),
    ...mapActions('notifications', ['triggerSnackbar']),

    async loadData() {
      try {
        await Promise.all([
          this.fetchSchema(),
          this.sectionsHCPandRoute(this.$route),
        ]);

        if (this.hasPermission) {
          await this.fetchRecords();
        } else {
          this.overlay = true;
          this.overlayMessage = 'No tiene acceso a esta sección. Solicite permisos.';
        }
      } catch (error) {
        this.handleDataError(error, 'Error al cargar datos.');
      }
    },

    toggleOverlay() {
      this.overlay = !this.overlay;
      if (!this.overlay && this.$route.name !== 'index') {
        this.$router.replace({ name: 'index' });
      }
    },

    async save() {
      try {
        const cognitiveAspectId = this.numCog;
        const model = {
          modelList1: this.modelList1,
          modelList2: this.modelList2,
          cognitiveAspectId,
        };
        const action = this.isNewRecord ? 'createRecord' : 'updateRecord';
        await this[action]({ model });

        const message =
          this.status === 'success'
            ? this.sanitizeText(this.schema?.snackOk || 'Guardado correctamente.')
            : this.sanitizeText(this.schema?.snackError || 'Error al guardar.');

        this.showSnackbar(message, this.status === 'success' ? 'success' : 'error');

        this.fetchRecords();
      } catch (error) {
        console.error('Error al guardar:', error);
        this.showSnackbar(
          this.sanitizeText(this.schema?.snackError || 'Error inesperado.'),
          'error'
        );
      }
    },

    handleEvents() {},

    handleDataError(error, message) {
      console.error(message, error);
      this.showSnackbar(message, 'error');
    },

    showSnackbar(content, color) {
      this.triggerSnackbar({ content, color });
    },

    sanitizeText(text) {
      return text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    },
  },
};
</script>

<style>
.barLateral {
  min-width: 60px;
}

.contentCentral {
  width: 96%;
}

.contentCardCentral {
  width: 98.5%;
  margin-top: 90px;
}

.contentRowCentral {
  width: 80%;
  min-height: 390px;
}

.contentForm {
  min-height: 390px;
}

.contentList {
  width: 700px;
}

.bannerAction {
  width: 87%;
  height: 48px;
}
</style>
